import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Select from '../../shared/reactSelect/select.component';
import { OptionsPropType } from '../../shared/propTypes/common';

export default class ParamSelect extends PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    options: OptionsPropType,
    onChange: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    disable: PropTypes.bool,
  };

  updateSelectValue = ({ value }) => {
    this.props.onChange({ [this.props.name]: value });
  };


  render() {
    const {
      name,
      value,
      options,
      isLoading,
      disable,
    } = this.props;

    return (
      <Select
        className="select-custom-param"
        onChange={this.updateSelectValue}
        name={name}
        value={value}
        clearable={false}
        options={options}
        virtualized
        isLoading={isLoading}
        disabled={disable}
      />
    );
  }
}
